import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-courses-style-six',
    templateUrl: './courses-style-six.component.html',
    styleUrls: ['./courses-style-six.component.scss']
})
export class CoursesStyleSixComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}